import { render, staticRenderFns } from "./PowerupViewComponent.vue?vue&type=template&id=565ddcc4&scoped=true"
import script from "./PowerupViewComponent.vue?vue&type=script&lang=ts"
export * from "./PowerupViewComponent.vue?vue&type=script&lang=ts"
import style0 from "./PowerupViewComponent.vue?vue&type=style&index=0&id=565ddcc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565ddcc4",
  null
  
)

export default component.exports